import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-56422d76"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"width":"100%","overflow-x":"hidden"} }
const _hoisted_2 = { class: "banner" }
const _hoisted_3 = { class: "textbox" }
const _hoisted_4 = { class: "banner-text1" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "首页", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "新闻动态", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "详情", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "banner-text2" }, "关注移动数字证书（CA）互认最新动态，了解最新政策", -1))
const _hoisted_9 = { class: "news-content" }
const _hoisted_10 = { class: "left" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "政策资讯", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line1" }, null, -1))
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "news-time" }
const _hoisted_15 = { class: "right" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "最新动态", -1))
const _hoisted_17 = { class: "content" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "pagination" }

import { reactive, toRefs, ref, onMounted } from 'vue'

import { getNews } from '../utils/axios/index.js'

import { useRoute } from 'vue-router'
import { useRouter } from "vue-router";

export default /*#__PURE__*/_defineComponent({
  __name: 'news',
  setup(__props) {

const route = useRoute()
const router = useRouter();
const tous = () => {
    router.push('/contactUs')
}

onMounted(() => {

    getNews(newParms.value).then(res => {
        newsList.value = res.data.records
        newParms.value.total = res.data.total
        newsList2.value = res.data.records.slice(0, 6)
    }).catch(err => {
        console.log(err);
    })

})

const handleSizeChange = (val) => {
    newParms.value.size = val
    getNews(newParms.value).then(res => {
        newsList.value = res.data.records
        newParms.value.total = res.data.total
    }).catch(err => {
        console.log(err);
    })
}

const handleCurrentChange = (val) => {
    newParms.value.current = val
    getNews(newParms.value).then(res => {
        newsList.value = res.data.records
        newParms.value.total = res.data.total
    }).catch(err => {
        console.log(err);
    })
}

let newsList = ref([])
let newsList2 = ref([])

let newParms = ref({
    current: 1,
    size: 50,
    total: 0,
})

let tabsList = ref([
    { name: 'CA互认政策新闻', isHovered: false, isActive: true, value: 1, },
    { name: '中招动态', isHovered: false, isActive: false, value: 2, },

])
let activeName = ref('1')
const toggleActive = (item: any) => {
    tabsList.value.map((item: any) => {
        item.isActive = false;
    })

    item.isActive = true;
    activeName.value = item.value
}
let showNewsDetail = ref(false)
const toNewsDetail = (url) => {
    // showNewsDetail.value = true
    window.open(url, '_blank');
}

const goBack = () => {
    showNewsDetail.value = false
}




let currentPage = ref(1)
let pageSize = ref(100)


return (_ctx: any,_cache: any) => {
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _withDirectives(_createElementVNode("span", {
              onClick: goBack,
              style: {"cursor":"pointer"}
            }, [
              _createTextVNode(" < 返回< /span>   "),
              _hoisted_5,
              _createTextVNode(" > "),
              _hoisted_6,
              _createTextVNode(" > "),
              _hoisted_7
            ], 512), [
              [_vShow, _unref(showNewsDetail)]
            ])
          ]),
          _hoisted_8
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _hoisted_12,
          _withDirectives(_createElementVNode("div", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(newsList), (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "news-box",
                key: index
              }, [
                _createElementVNode("div", {
                  class: "news-title",
                  onClick: ($event: any) => (toNewsDetail(item.newsUrl))
                }, _toDisplayString(item.newsTitle), 9, _hoisted_13),
                _createElementVNode("div", _hoisted_14, _toDisplayString(item.publishTime), 1)
              ]))
            }), 128))
          ], 512), [
            [_vShow, !_unref(showNewsDetail)]
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _createElementVNode("div", _hoisted_17, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(newsList2), (item) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "news-item",
                onClick: ($event: any) => (toNewsDetail(item.newsUrl))
              }, _toDisplayString(item.newsTitle), 9, _hoisted_18))
            }), 256))
          ])
        ])
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_19, [
        _createVNode(_component_el_pagination, {
          "current-page": _unref(newParms).current,
          "onUpdate:currentPage": _cache[0] || (_cache[0] = ($event: any) => ((_unref(newParms).current) = $event)),
          "page-size": _unref(newParms).size,
          "onUpdate:pageSize": _cache[1] || (_cache[1] = ($event: any) => ((_unref(newParms).size) = $event)),
          "page-sizes": [50, 100, 150, 200],
          layout: "prev, pager, next,sizes,",
          total: _unref(newParms).total,
          background: "",
          onSizeChange: handleSizeChange,
          onCurrentChange: handleCurrentChange
        }, null, 8, ["current-page", "page-size", "total"])
      ], 512), [
        [_vShow, !_unref(showNewsDetail)]
      ]),
      _createElementVNode("div", { class: "bigbottom" }, [
        _createElementVNode("div", {
          class: "bottom",
          onClick: tous
        })
      ])
    ])
  ]))
}
}

})